import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation sendTimeRegEmailMutation($input: SendTimeRegEmailInput!) {
		sendTimeRegEmail(input: $input) {
			clientMutationId
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Reminder email sent');
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
